import LinkCard from './linkCard';

export default LinkCard;
